module.exports = __webpack_public_path__ + "img/research2.e487e99b.png";